/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-05-20 14:30:34
 * @LastEditTime: 2020-12-24 15:34:36
 */
import http from '@/axios/http'
import store from '@/store'
import { getuser_id } from "@/localStorage/localStorage";
/**
 * 
 * @param {*} funTag 平台菜单标记，0代表获取设备管理服务端的菜单，1代表云监测菜单
 */
export function UserGetMenu(funTag) {
    const data = {
        user_id: getuser_id(),
        funTag: funTag
    }
    return http({
        url: '/api/config/getMenu',
        method: 'post',
        data
    })
}